import { Grid } from '@mui/material';
import { HSpacer, RoutalPalette } from '@nx-smartmonkey/ui';

import CheckIcon from '@mui/icons-material/Check';
import CrossIcon from '../../../../../../assets/svg/CrossIcon';
import { LoadingButton } from '../../../../../../components/LoadingButton';
import { Text } from '../../../../../../react-components/Text';

export type ReportFooterType = `cancel` | `complete`;
export const ReportFooter = {
  cancel: `cancel`,
  complete: `complete`,
};

interface StopReportFooterProps {
  onClick: () => void;
  report?: ReportFooterType;
  isLoading?: boolean;
}

export const StopReportFooter = ({ onClick, report, isLoading }: StopReportFooterProps) => {
  return (
    <Grid
      container
      style={{
        display: `flex`,
        flexDirection: `row`,
        justifyContent: `space-evenly`,
        alignContent: `center`,
        flexWrap: `nowrap`,
        padding: `0px 20px`,
        height: `70px`,
        alignItems: `center`,
        borderTop: `1px solid ${RoutalPalette.neutral10}`,
        width: `100%`,
        background: RoutalPalette.white,
      }}
    >
      {report === `complete` ? (
        <LoadingButton
          isLoading={isLoading}
          style={{
            height: `42px`,
            backgroundColor: RoutalPalette.success.medium,
            borderColor: RoutalPalette.success.medium,
            display: `flex`,
            flexDirection: `row`,
            flexWrap: `nowrap`,
            justifyContent: `center`,
            alignItems: `center`,
            borderRadius: `10px`,
            width: `100%`,
          }}
          onClick={(e: any) => {
            if (!isLoading) {
              onClick();
            }
          }}
        >
          <CheckIcon style={{ fill: RoutalPalette.white, height: `24px`, width: `22px` }} />
          <HSpacer small />
          <Text intlId={`drivers.stop.report.complete_stop`} style={{ color: RoutalPalette.white, fontSize: `15px` }} />
        </LoadingButton>
      ) : (
        <LoadingButton
          isLoading={isLoading}
          style={{
            height: `42px`,
            backgroundColor: RoutalPalette.error.medium,
            borderColor: RoutalPalette.error.medium,
            display: `flex`,
            flexDirection: `row`,
            flexWrap: `nowrap`,
            justifyContent: `center`,
            alignItems: `center`,
            borderRadius: `10px`,
            width: `100%`,
          }}
          onClick={(e: any) => {
            if (!isLoading) {
              onClick();
            }
          }}
        >
          <CrossIcon style={{ fill: RoutalPalette.white, height: `18px`, width: `18px` }} />
          <HSpacer small />
          <Text intlId={`drivers.stop.report.cancel_stop`} style={{ color: RoutalPalette.white, fontSize: `15px` }} />
        </LoadingButton>
      )}
    </Grid>
  );
};
